import React from 'react';
import {Divider, Space} from 'antd';
import Flex from '../Flex';

import logoSquare from '../../assets/logo-square.png';
import qrcode from '../../assets/qrcode.png';
import moment from 'moment';

export default function AppFooter() {
  return (
    <div className={'AppFooter'}>
      <div className={'AppFooterContainer'}>
        <Space>
          <a className={'FooterLink'} href="/">
            首页
          </a>
          <Divider type="vertical" />
          <a className={'FooterLink'} href="/">
            关于 SCS
          </a>
          <Divider type="vertical" />
          <a className={'FooterLink'} href="/">
            组织架构
          </a>
          <Divider type="vertical" />
          <a className={'FooterLink'} href="/">
            会议活动
          </a>
          <Divider type="vertical" />
          <a className={'FooterLink'} href="/">
            品牌活动
          </a>
          <Divider type="vertical" />
          <a className={'FooterLink'} href="/">
            联系我们
          </a>
        </Space>
        <Divider />
        <Flex justify={'space-between'} style={{padding: '30px 50px'}} align={'center'}>
          <Flex align={'center'}>
            <img src={logoSquare} style={{width: 200, marginRight: 30}} />
            <div className={'text-left'}>
              <p>上海市计算机学会 ©2005-{moment().format('YYYY')} All Rights Reserved</p>
              <a href="https://beian.miit.gov.cn//">
                <p>沪ICP备19032017号-1</p>
              </a>
              <p>地址：上海市南昌路47号3号楼303室</p>
              <p>电话：021-53828933</p>
              <p>E-mail：computer@stn.sh.cn</p>
              <p>工作时间：周一至周日 09:00-17:00（节假日除外）</p>
            </div>
          </Flex>
          <img src={qrcode} style={{width: 180}} />
        </Flex>
      </div>
    </div>
  );
}
